import { useCallback, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../service'

async function fetchTemplates (clientId) {
  const { data } = await postNamedQuery('coreData', 'execute-redtail-domain-query', {
    query: 'listWorkflowTemplates',
    autoResolveConnection: true,
    clientId,
    request: {}
  })
  return (data?.workflow_templates ?? []).filter(t => !t.deleted)
}

export default function useWorkflowTemplates (clientId, enabled = true) {
  const { data: templates = [] } = useQuery({
    queryKey: ['redtail-workflow-templates', clientId],
    queryFn: () => fetchTemplates(clientId),
    staleTime: 10 * 60 * 1000,
    enabled: !!clientId && enabled
  })

  // The list response `id` field is not unique (returns status=1 for all active
  // templates). Use `redtail_one_id` (CTP identifier) as the stable unique key.
  const options = useMemo(
    () => templates.map(t => ({
      label: t.name?.trim() || `Template ${t.redtail_one_id}`,
      value: t.redtail_one_id
    })),
    [templates]
  )

  const templatesByKey = useMemo(() => {
    const map = {}
    for (const t of templates) {
      if (t.redtail_one_id) map[t.redtail_one_id] = t
    }
    return map
  }, [templates])

  const getTemplate = useCallback(
    (ctpId) => templatesByKey[ctpId] ?? null,
    [templatesByKey]
  )

  return { options, getTemplate }
}
